function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaretdoubleright(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72 3.97a.75.75 0 000 1.06L11.69 12l-6.97 6.97a.75.75 0 101.06 1.06l7.5-7.5a.75.75 0 000-1.06l-7.5-7.5a.75.75 0 00-1.06 0z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.22 3.97a.75.75 0 000 1.06L19.19 12l-6.97 6.97a.75.75 0 101.06 1.06l7.5-7.5a.75.75 0 000-1.06l-7.5-7.5a.75.75 0 00-1.06 0z",
    fill: props.fill
  }));
}

export default SvgCaretdoubleright;